import { Typography } from '@breetometer/components';
import { AnimatedLoaderIcon } from 'BreetAssets';
import { useModalApi } from 'BreetHooks';

const LoadingDialog = () => {
	const { getModalProps } = useModalApi();

	const data = getModalProps('loadingDialog')?.metadata as { message?: string } | undefined;

	return (
		<div className='loading_dialog'>
			<AnimatedLoaderIcon />
			<Typography
				as='p'
				id='loading-dialog-message'
			>
				{data?.message ?? ''}
			</Typography>
		</div>
	);
};

export default LoadingDialog;
